module.exports = __webpack_public_path__ + "static/media/bg-japan-miso.92522d5b.png";